import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import forwardRefPropType from "../utils/forward-ref";
import ModalOverlay from "./Overlay";

const Modal = ({
	size = "m",
	className = "",
	open = true,
	center = true,
	simple = false,
	overlay = false,
	children,
	forwardRef,
	...props
}) => {
	return (
		<>
			{overlay && <ModalOverlay />}
			<div
				ref={forwardRef}
				tabIndex="-1"
				className={classes("modal", open && "modal--open", className)}
				{...props}
			>
				<div
					className={classes(
						"modal__dialog",
						size && `modal__dialog-${size}`,
						center && "modal__dialog--centered",
						simple && "modal__dialog--simple",
						className,
					)}
				>
					<div className="modal__content">{children}</div>
				</div>
			</div>
		</>
	);
};

Modal.propTypes = {
	size: oneOf(["s", "sm", "m", "l", "auto"]),
	title: string,
	className: string,
	open: bool,
	center: bool,
	simple: bool,
	overlay: bool,
	children: node.isRequired,
	forwardRef: forwardRefPropType,
};

export default Modal;
